import dynamic from 'next/dynamic';

import { BookAnotherRoomProps } from './BookAnotherRoom.types';

export const BookAnotherRoom = dynamic<BookAnotherRoomProps>(() =>
  import('./BookAnotherRoom').then(module => module.BookAnotherRoom)
);
